import { WalletSkeletonPurpleBox } from "../../../../style/skeleton";
import {
  WalletPubHeaderButton,
  WalletPubHeaderText,
  WalletPubHeaderUser,
  WalletPubHeaderValue,
  WalletPubHeaderWarpper,
} from "./style";

const WalletPubHeaderSkeleton = () => {
  return (
    <WalletPubHeaderWarpper>
      <WalletPubHeaderText>
        <WalletPubHeaderUser>
          <div className="text">
            <WalletSkeletonPurpleBox width="150px" height="16px" />
          </div>
          <WalletPubHeaderValue>
            <WalletSkeletonPurpleBox width="120px" height="22px" />
          </WalletPubHeaderValue>
        </WalletPubHeaderUser>
      </WalletPubHeaderText>
      <WalletPubHeaderButton>상세내역</WalletPubHeaderButton>
    </WalletPubHeaderWarpper>
  );
};

export default WalletPubHeaderSkeleton;
